import {IMovieCinemeData} from './index'
export const initCinamaMovieData:IMovieCinemeData = {
  hasNext: false,
  searches: [],
  totalCount:0
}
